import React, { useEffect } from "react";
import { connect, useSelector } from "react-redux";
import {Card} from "react-bootstrap"
import { getBotDetail } from "../../../actions/bot-action";

const BotStatisticsView = (props)=>{
    const {bot,getBotDetail,t} = props
    
    const selectedBot = useSelector((state) => state.newTemplate.botSelected) || {};
    useEffect(() => {
        bot.id && getBotDetail(bot.id)
    }, []);
    const analysis = selectedBot.deals_analysis
    return (
        <>
        
         <Card className="bot-statistics-div">
           
            <Card.Body className="round-bg">
            {selectedBot.deals_analysis ? 
                (<>
                <p className="bot-stats-heading">{bot.name} {t("bots-stats")}</p>
                <ul className="bot-stats-info">
                    <li>
                        <div>APY</div> <div>{analysis?analysis.apy:'0'}%</div> 
                    </li>
                    <li>
                        <div>{t("performance")}</div> <div>{analysis?analysis.total_performance:'0'}%</div> 
                    </li>
                    <li>
                        <div>{t("w-l-ratio")}</div> <div>{analysis?analysis.wl_ratio:'0'}%</div> 
                    </li>
                    <li>
                        <div>{t("total-deals")}</div> <div>{analysis ? analysis.total_position:0}</div> 
                    </li>
                    <li>
                        <div>{t("a-md-d")}</div> <div>{analysis?analysis.avg_monthly_deal:'0'}</div> 
                    </li>
                    <li>
                        <div>{t("strategy")}</div> <div>{selectedBot?selectedBot.strategy:""}</div> 
                    </li>
                </ul>
                </>):(<p className="bot-stats-heading">{t("pls-sel-bot")}</p>)
            }
                
            </Card.Body>
        </Card>
        </>
    )
}
export default connect(null,{getBotDetail})(BotStatisticsView)